/**
 * Context Kinds are billed per unique context key. Only use context keys that are reasonable unique keys.
 *
 * For example, user IDs are not valid keys. Team is likely the most unique key we can tolerate.
 */
export enum FeatureFlagContextKind {
  TEAM = "team",
  SEARCH_INDEX = "search-index",
  SYSTEM = "system",
  USER = "user", // WARNING: This is an expensive context kind. Be sure you actually want to use it.
  COLLECTION = "mongodb-collection", // MongoDB collection name as context key
  CLAIM_SUBMISSION_METHOD = "claim-submission-method", // Claim submission method (usps/ups/fedex/...) as context key
  TEMPORAL_NAMESPACE = "temporal-namespace", // Temporal namespace name as context key
  SERVICE = "service", // DD_SERVICE as context key, with its cost-owner `cloud` as an attribute
}

export type FeatureFlagKey = string;

export enum FeatureFlagNumericMetricKey {
  EXCHANGE_REQUEST_SUBMITTED = "exchange-request-submitted",
}
